<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { usePaymentStore } from '@/store/paymentStore';
import { useAgentStore } from "@/store/agentStore";


import moment from 'moment';

import Swal from "sweetalert2";


import { ref } from "vue";


/**
 * Dashboard Component
 */
export default {
    setup() {
        const doesAddOpen = ref(false);
        const doesViewOpen = ref(false);
        const doesDeleteOpen = ref(false);
        const doesLoadingOpen = ref(false);
    const paymentStore = usePaymentStore();
    const agentStore = useAgentStore();



        return {
          doesAddOpen,
          doesViewOpen,
          doesDeleteOpen,
          doesLoadingOpen,
          paymentStore,
          agentStore,

        };
    },
    page: {
    title: "Payments",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "payment",
      items: [
        {
          text: "Menu",
        },
        {
          text: "payment",
          active: true,
        },
      ],
      errors: [],
      payments: [],
      payment: undefined,
      transfer_search: [],
      state: "",
      states: [{
        "key": "TOUT"
      }, {
        "key": "EN ATTENTE"
      }, {
        "key": "PROUVEE"
      }, {
        "key": "EN COURS"
      }, {
        "key": "TRANSFERER"
      }, {
        "key": "TERMEINE"
      }, {
        "key": "ECHOUE"
      }],
      search: '',
      loading: false,
      status: 201,
      page: 1,
      agents: [],
      perPage: 25,
    };
  },
  methods: {


    
     
  async loadFromStore() {

      if (!this.paymentStore.list) {
       await  this.paymentStore.loadFromApi(true).then(data => {
        this.payments = data
        this.payment_search = data;
        this.length = this.payments.length;
    })
      } else {
        this.payments = this.paymentStore.list
        this.payment_search = this.payments;
                this.length = this.payments.length;

      }

  },

 async   refresh(){
       await  this.paymentStore.loadFromApi(true).then(data => {
        this.payments = data
        this.payment_search = data;
        this.length = this.payments.length;
    })
    },


    show(index) {
        return (index < this.page * this.perPage && (index + 1) > (this.page - 1) * this.perPage)
    },
    next() {
        if ((this.page * this.perPage) < this.payments.length) {
            this.page++
        }
    },
    previous() {
        if (this.page >= 2) {
            this.page--
        }
    },

    async loadAgents() {
      if (!this.agentStore.list) {
        await this.agentStore.loadFromApi().then((data) => {
          this.agents = data;
        });
      } else {
        this.agents = this.agentStore.list;
      }
    },
    filter_transfer() {
      this.payments = this.transfer_search
      if (this.search != "") {
        this.payments = this.payments.filter(payment => (
          payment.idOfTransfer?.includes(this.search) ||
          payment.idOfAgent?.includes(this.search) ||
          payment.payId?.includes(this.search) ||
          payment.provenAt?.includes(this.search) ||
          payment.confirmedAt?.includes(this.search) ||
          payment.cancelledAt?.includes(this.search) 
          ))
      }
    },
    convertDate(date) {
      return moment.utc(date).format('DD-MM') + " " + moment.utc(date).format('HH:mm')
    },

    compileToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.onmouseenter = Swal?.stopTimer;
            toast.onmouseleave = Swal?.resumeTimer;
          }
        });
        Toast.fire({
          icon: "success",
          title: "Le texte a été copié dans le presse-papier.",
        });
      });
      
    },
     truncateEmail(email) {
      if (email.length > 15) {
        return email.slice(0, 13) + '...'; // Récupère les 17 premiers caractères et ajoute "..."
      }
      return email; // Retourne l'email tel quel si sa longueur est inférieure ou égale à 20
    },


     getExtension(payout) {
      return payout.proof?.split(".")?.pop()?.toLowerCase();
    },
    isImage(payout) {
      const extensions = ["jpg", "jpeg", "png", "gif"];
      return extensions.includes(this.getExtension(payout));
    },
    isPDF(payout) {
      return this.getExtension(payout) === "pdf";
    },


    onViewItem(payment, action = "view") {
      this.payment = payment
      if (action == "delete") {
        console.log('')
      } else {
        this.doesViewOpen = true
      }
    },
   
    getPayoutStatus(payout) {
      if (payout.cancelledAt) return "cancelled";
      if (payout.provenAt) return "proven";
      if (payout.tookAt) return "processing";
       return "pending";
    },

    getPayoutDate(payout) {
      return payout.cancelledAt ?? payout.provenAt ?? payout.tookAt ?? payout.createdAt;
    },

    getAgentInfo(payment) {
      if (!payment.idOfAgent) {
        return '';
      }
      const agent = this.agentStore.getOne(payment.idOfAgent);
      if (agent?.user) {
        return `${agent.user.lastName} ${agent.user.firstName}`
      } else {
        return payment.idOfAgent;
      }
    },
  },
  mounted() {
    this.loadFromStore();
    this.loadAgents();

    this.doesLoadingOpen = false
  },
  watch: {
    doesViewOpen: function () {
      if (!this.doesEditOpen) {
        this.payment = null
      }
    },
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="hstack mb-3" v-show="status != 403">
      <b-button variant="primary" @click="refresh()" class="ms-auto">
        <i class=" bx bx-refresh font-size-16 align-middle me-2"></i>
        Refresh
      </b-button>
    </div>

    <div class=" row mb-3" v-show="status != 403">
      <div class="col-6  col-md-4 ">
        <input type="search" class="form-control" v-model="search" v-on:input="filter_transfer()"
          placeholder="Rechercher une transfer">
      </div>

      <div class="col-4 col-sm-2 ms-auto ms-md-3">
        <select name="" id="" v-model="state" class="form-control text-center bg-secondary text-white">
          <option value="">Statut</option>
          <option v-for="state in states" :key="state.key" :value="state.key">{{ state.key }}</option>
        </select>
      </div>

      <div class=" col-5 col-sm-2 ms-0 ms-md-3 mt-3 mt-md-0">
        <select v-model="perPage" class="form-control text-center">
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
          <option value="500">500</option>
        </select>
      </div>

      <div class="ms-auto   col-6 col-sm-2 ps-5  mt-4 mt-md-0 ms-md-3">
        <i class="bx bx-left-arrow-alt p-2 fs-5 fs-sm-1" type="button" @click="previous"></i>

        <small class="ms-3 ">
          {{ Math.ceil(payments.length / perPage) > 0 ? page : 0 }} /
          {{ Math.ceil(payments.length / perPage) }}
        </small>

        <i class="bx bx-right-arrow-alt fs-5 fs-sm-1 p-2 ms-3 " type="button" @click="next"></i>
      </div>


    </div>

    <div class="row" v-show="status != 403">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listes des transfers</h4>
            <p class="card-title-desc">
              Le tableau ci-dessous présente la listes des <code>transfers</code>.
            </p>

            <div class="table-responsive">
              <table class="table align-middle mb-0">
                <thead class="bg-light rounded">
                  <tr>
                    <th>#</th>
                    <th>Transfer</th>
                    <th>agent</th>
                    <th>payId</th>
                    <th>proof</th>
                    <th>Status</th>
                    <th>Account</th>
                    <th>Wallet</th>
                    <th>Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in payments" v-show="show(i)" :key="item.id">
                    <th scope="row" v-on:click="compileToClipboard(item.id)" style="cursor: pointer;">{{ i + 1 }}</th>
                    <td v-on:click="compileToClipboard(item.idOfTransfer)" style="cursor: pointer;">{{ item.idOfTransfer
                      }}</td>
                    <td v-on:click="compileToClipboard(item.idOfAgent)" style="cursor: pointer;">{{ getAgentInfo(item)
                      }}</td>
                    <td>{{ item.payId }}</td>
                    <td>
                      <a v-if="item?.proof" :href="item?.proof" target="_blank">
                        <div v-if="isImage(item)">
                          <img :src="item.proof" alt="Aperçu image" style="width: 50px; height: auto;" />
                        </div>
                        <div v-else-if="isPDF(item)">
                          <i class="fas fa-payout-pdf" style="color: red;"></i> PDF
                        </div>
                        <div v-else>
                          <i class="fas fa-payout-alt"></i> {{ item.extension.toUpperCase() }}
                        </div>
                      </a>

                    </td>
                    <td>{{ getPayoutStatus(item) }}</td>
                    <td>{{ item.account?.number ?? item.idOfAccount}}</td>
                    <td>{{ item.wallet?.number ?? item.idOfWallet ?? '' }}</td>

                    <td>{{ convertDate(getPayoutDate(item)) }}</td>
                    <td>
                      <b-button class="btn-sm ms-2" @click="onViewItem(item, 'view')" variant="success">
                        <i class="bx bx-edit font-size-16 align-middle mx-1"></i>
                      </b-button>

                    </td>
                  </tr>
                </tbody>
              </table>
            </div>


          </div>
        </div>
      </div>
    </div>


    <div v-show="status === 403">
      <h3 class="text-danger text-center my-5">Vous n'êtes pas encore ajouté, demandez à l'administrateur principal.
      </h3>
    </div>

    <!-- LOADING MODAL -->
    <b-modal v-model="doesLoadingOpen" id="modal-center" centered size="md" title="Chargement..." title-class="font-18"
      hide-footer>
      <div class="text-center">
        <div class="spinner-border text-primary-" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </b-modal>



    <b-modal v-model="doesViewOpen" id="modal-view-payment" centered size="lg" title="Détail du paiement"
      title-class="font-18" hide-footer v-if="payment">
      <div class="p-3">
        <div class="mb-3 row">
          <label class="col-sm-4 fw-bold">ID du paiement:</label>
          <div class="col-sm-8">{{ payment.payId }}</div>
        </div>

        <div class="mb-3 row" v-if="payment.proof">
          <label class="col-sm-4 fw-bold">Preuve:</label>
          <div class="col-sm-8">
            <a :href="payment.proof" target="_blank">
              <img v-if="isImage(payment)" :src="payment.proof" alt="Image" style="max-height: 100px;" />
              <span v-else-if="isPDF(payment)">PDF</span>
              <span v-else>{{ getExtension(payment).toUpperCase() }}</span>
            </a>
          </div>
        </div>

        <div class="mb-3 row">
          <label class="col-sm-4 fw-bold">Leave:</label>
          <div class="col-sm-8">{{ payment.leave }} FCFA</div>
        </div>

        <div class="mb-3 row">
          <label class="col-sm-4 fw-bold">Surplus:</label>
          <div class="col-sm-8">{{ payment.surplus }} FCFA</div>
        </div>

        <div class="mb-3 row" v-if="payment.refound">
          <label class="col-sm-4 fw-bold">Refound:</label>
          <div class="col-sm-8">{{ payment.refound }}</div>
        </div>

        <div class="mb-3 row" v-if="payment.topics?.length">
          <label class="col-sm-4 fw-bold">Topics:</label>
          <div class="col-sm-8">{{ payment.topics.join(', ') }}</div>
        </div>

        <div class="mb-3 row" v-if="payment.receipts?.length">
          <label class="col-sm-4 fw-bold">Reçus:</label>
          <div class="col-sm-8">{{ payment.receipts.join(', ') }}</div>
        </div>

        <div class="mb-3 row">
          <label class="col-sm-4 fw-bold">Agent:</label>
          <div class="col-sm-8">{{ getAgentInfo(payment) }}</div>
        </div>

        <div class="mb-3 row">
          <label class="col-sm-4 fw-bold">Compte Agent:</label>
          <div class="col-sm-8">{{ payment.account?.number ?? payment.idOfAccount }}</div>
        </div>

        <div class="mb-3 row" v-if="payment.getter">
          <label class="col-sm-4 fw-bold">Bénéficiaire:</label>
          <div class="col-sm-8">{{ payment.getter?.lastName }} {{ payment.getter?.firstName }}</div>
        </div>

        <div class="mb-3 row" v-if="payment.name">
          <label class="col-sm-4 fw-bold">Name:</label>
          <div class="col-sm-8">{{ payment.name }}</div>
        </div>

        <div class="mb-3 row" v-if="payment.confirmedAt">
          <label class="col-sm-4 fw-bold">Payed At:</label>
          <div class="col-sm-8">{{ convertDate(payment.payedAt) }}</div>
        </div>

        <div class="mb-3 row" v-if="payment.provenAt">
          <label class="col-sm-4 fw-bold">Proven At:</label>
          <div class="col-sm-8">{{ convertDate(payment.provenAt) }}</div>
        </div>


        <div class="mb-3 row" v-if="payment.cancelledAt">
          <label class="col-sm-4 fw-bold">Cancelled At:</label>
          <div class="col-sm-8">{{ convertDate(payment.cancelledAt) }}</div>
        </div>

        <div class="mb-3 row" v-if="payment.confirmedAt">
          <label class="col-sm-4 fw-bold">Confirmed At:</label>
          <div class="col-sm-8">{{ convertDate(payment.confirmedAt) }}</div>
        </div>



        <div class="mb-3 row">
          <label class="col-sm-4 fw-bold">Statut:</label>
          <div class="col-sm-8">{{ getPayoutStatus(payment) }}</div>
        </div>

        <div class="mb-3 row" v-if="payment.olds">
          <label class="col-sm-4 fw-bold">Old:</label>
          <div class="col-sm-8">{{ payment.olds?.join(', ') }}</div>
        </div>

        <div class="mb-3 row">
          <label class="col-sm-4 fw-bold">Date:</label>
          <div class="col-sm-8">{{ convertDate(getPayoutDate(payment)) }}</div>
        </div>

        <div class="text-end">
          <b-button variant="secondary" @click="doesViewOpen = false">Fermer</b-button>
        </div>
      </div>
    </b-modal>



  </Layout>
</template>
